import {
  FilterMode,
  ReportTypeCreateMutationVariables,
  ReportType_OrderBy,
  ReportType,
  SortOrder,
  ReportType_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const reportTypeService = {
  createOne: buildCreateOne(
    (reportTypeCreateVariables: ReportTypeCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.reportTypeCreate(reportTypeCreateVariables);
        return result.reportTypeCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.reportTypeOne({ id });
    return result.reportTypeOne as ReportType;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: ReportType_OrderBy[] | null = null,
    filter: ReportType_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: ReportType_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.reportTypeListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.reportTypeListWithOffset
    ) as ReportType[];
    return { list, orderBy };
  },
};
